module.exports = __webpack_public_path__ + "media/theme/tutorial__itunes_2019--7-17e136e8.png";